module.exports = __webpack_public_path__ + "media/backgrounds/vitalik-vynarchyk-TUzsO59UFpo-unsplash-ca82d302.jpg";